import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
    selector: 'prof-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.scss'],
    standalone: false
})
export class SsoComponent implements OnInit {

  constructor(private readonly _auth: AuthService, private readonly _route: ActivatedRoute) { }

  ngOnInit(): void {
    this._route
      .queryParamMap
      .pipe(
        map(params => params.get('route_from'))
      ).subscribe((routefrom: string) => {
        this._auth.routeFrom = routefrom;
      });

    this._route
      .queryParamMap
      .pipe(
        map(params => params.get('route_to'))
      ).subscribe((routeto: string) => {
        this._auth.routeTo = routeto;
      });

      this._auth.isAuthenticated$.pipe(
      filter(isAuthenticated => isAuthenticated === true)
    ).subscribe(() => {
      this.handleAuthenticatedUser();
    });

    this._auth.isAuthenticated$.pipe(
      filter(isAuthenticated => isAuthenticated === false)
    ).subscribe(() => {
      this.handleUnauthenticatedUser();
    });
  }

  private handleAuthenticatedUser(): void {
    this._auth.getUser$().subscribe(u => {
      this._auth.loginRedirect();
    });
  }

  private handleUnauthenticatedUser(): void {
    this._auth.login();
  }
}